<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :ignoreMaxTableItemLimit="true"
                                           :query-api="findAllByVendor"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :ignoreMaxTableItemLimit="true"
                                      :ignoreAdd="true" :ignoreDelete="true" :editDisable="true"
                                      detailInlineButtonType="showAttachmentEntity"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      :query-api="findAllByVendor"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <batch-upload-attachment-with-store
                                        title="批量上传质量文件"
                                        attachmentFieldName="qualityFileIds"
                                        :modelName="modelName"
                                        :doQuery="doQuery"
                                        :voName=$_emCustomVuexMixin_vo
                                    />
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled= false
                                        custom-label="导入更新供货日期" show-name
                                        :busy="uploadFile"
                                        @click="openFileUpload">
                                    </em-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <b-modal id="modal-import" ref="importModal" title="导入数据" hide-footer>
            <b-form @submit="handleSubmit" @reset="handleReset">
                <b-form-group
                    id="templateFile"
                    label="选择数据源文件:"
                    label-for="input-dataFile"
                    invalid-feedback="必须选择数据源">
                    <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2"
                                 :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件"
                                 :file-name-formatter="formatNames"
                                 accept=".xls,.xlsx" required></b-form-file>
                </b-form-group>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">导入</b-button>
                    <b-button type="reset" variant="light">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-07-06 09:52:28

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import BatchUploadAttachmentWithStore from "@/components/common/attachment/BatchUploadAttachmentWithStore";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";

export default {
    name: "sithMesStoolPoListView",
    components: {MiniButton, BatchUploadAttachmentWithStore},
    mixins: [emCommonListMixin, emCommonApiMixin, commonViewsUtil, emCustomVuexMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            file: null,
            uploadFile: false,
            saveAttachmentLoading: false,
            findAllByVendor: 'findTotalByVendor',
            attachmentIds: '',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        $_emCustomVuexMixin_vo: {
            type: String,
            default: 'vendorVo'
        },
        $_emCustomVuexMixin_filter: {
            type: String,
            default: 'vendorFilter'
        },
    },
    computed: {
        modelName() {
            return 'sithMesStoolPo';
        },
        $_customVuexName() {
            return 'vendor'
        },
        $_rowMaterialKey() {
            return 'materialNumber';
        }
    },
    methods: {
        openFileUpload() {
            this.file = null;
            this.$refs.importModal.show();
        },
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`
        },
        handleSubmit(event) {
            event.preventDefault()
            let formData = new FormData();
            formData.append('file', this.file);

            this.$emit('begin');
            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/importFileUpdateDeliveryDate"
            this.$_emApiMixin_post(url, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    //让页面刷新数据
                    this.$store.commit(`${this.entity}/setNeedToRefresh`, true, {
                        root: true
                    })
                }).finally(() => this.$emit('end'));

            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
        handleReset() {
            this.selectedMachineType = null;
            this.file = null;
            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
        getDetailInlineButtonType(row) {
            if (row.poReport) {
                return 'showAttachmentEntity';
            }

            return 'showEntity';

        },
        doQuery() {
            this.$refs["emListFilter"].doQuery();
        }
    },
    mounted() {
        this.doQuery();
    }
};
</script>
